import * as action_types from './actionTypes'

export const openNotAuthorized = data => dispatch => {
  dispatch({
    type: action_types.OPEN_NOT_AUTHORIZED,
    payload: data
  })
}

export const closeNotAuthorized = data => dispatch => {
  dispatch({
    type: action_types.CLOSE_NOT_AUTHORIZED,
    payload: data
  })
}



// WEBPACK FOOTER //
// ./src/actions/notAuthorized.js